var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FormSelectTree',_vm._g(_vm._b({ref:"FormTreeSelect",attrs:{"multiple":"","load-options":_vm.loadOptions,"normalizer":_vm.normalizer,"disable-branch-nodes":""}},'FormSelectTree',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }